import { render, staticRenderFns } from "./DigitalSignAccount.vue?vue&type=template&id=45b183ce&"
import script from "./DigitalSignAccount.vue?vue&type=script&lang=js&"
export * from "./DigitalSignAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports